export const INVESTOR_LIFECYCLE_STATUS_OPTIONS = [
  'New Prospect',
  'First Contact Made',
  'Qualified Prospect',
  'Discovery Scheduled',
  'Proposal in Progress',
  'Prospect Reviewing Proposal',
  'Onboarding Client',
  'Active Client',
  'Unresponsive',
  'Not a Fit',
  'Lost / Declined',
] as const;

export type InvestorLifecycleStatus = (typeof INVESTOR_LIFECYCLE_STATUS_OPTIONS)[number];

export const DEFAULT_INVESTOR_LIFECYCLE_STATUS: InvestorLifecycleStatus = 'New Prospect';

export const INVESTOR_LIFECYCLE_STATUS_SELECT_OPTIONS = INVESTOR_LIFECYCLE_STATUS_OPTIONS.map(
  (status) => ({
    label: status,
    value: status,
  }),
);

export const normalizeInvestorLifecycleStatus = (
  value?: string | null,
): InvestorLifecycleStatus => {
  const normalized = value?.trim();
  return INVESTOR_LIFECYCLE_STATUS_OPTIONS.includes(normalized as InvestorLifecycleStatus)
    ? (normalized as InvestorLifecycleStatus)
    : DEFAULT_INVESTOR_LIFECYCLE_STATUS;
};
